'use client';

import { TypeformSnippet } from 'components/shared';
import { CaretUp } from 'assets/icons';
import { theme } from 'components/theme';
import styles from './metabolic-health-assessment-client.module.css';

export const StaticInfoCtaBar = ({ className }: { className?: string }) => {
  return (
    <div
      className={className ? `${styles.ctaBar} ${className}` : styles.ctaBar}
      onClick={() =>
        window.open(
          'https://form.typeform.com/to/yOi1E7Wy?utm_source=web',
          '_blank',
        )
      }
      role="button"
      tabIndex={0}
      onKeyDown={() =>
        window.open(
          'https://form.typeform.com/to/yOi1E7Wy?utm_source=web',
          '_blank',
        )
      }
    >
      <div className={styles.content}>
        Get the right plan.
        <span className={styles.subContent}>
          Talk to a specialist
          <CaretUp style={{ transform: 'rotate(90deg)' }} />
        </span>
      </div>
    </div>
  );
};

const HealthAssessment = () => {

  return (
    <main
      style={{
        backgroundColor: theme.colors.background,
        color: theme.colors.primary,
      }}
    >
      <div className={styles.container}>
        <TypeformSnippet
          typeformId="ALaQHrgD"
          frameTitle="Metabolic health assessment"
          className="typeform-container"
        />
      </div>
    </main>
  );
};

export default HealthAssessment;
